var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuarterCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9806",
    "data-name": "Group 9806",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 417.74,
    height: 425.897,
    viewBox: "0 0 417.74 425.897",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5298",
    "data-name": "Rectangle 5298",
    width: 417.74,
    height: 425.897,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9805",
    "data-name": "Group 9805",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9804",
    "data-name": "Group 9804"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9803",
    "data-name": "Group 9803",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9802",
    "data-name": "Group 9802",
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9801",
    "data-name": "Group 9801"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9800",
    "data-name": "Group 9800",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27709",
    "data-name": "Path 27709",
    d: "M417.74,391.487q-.1,17.145-1.68,33.91c-.01.17-.03.33-.04.5H342.18a4.016,4.016,0,0,0,.06-.5q.705-6.06,1.18-12.2a320.021,320.021,0,0,0-105.49-262.99,268.749,268.749,0,0,0-64.97-45.74A320.3,320.3,0,0,0,.5,72.337c-.16.02-.33.03-.5.04V1.187c.16-.02.33-.03.5-.04a391.02,391.02,0,0,1,102.29,5.62A396.058,396.058,0,0,1,385,232.287a403.1,403.1,0,0,1,32.74,159.2",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27710",
    "data-name": "Path 27710",
    d: "M128.28,425.4c-.06.17-.12.34-.18.5H0V287.427c.16-.05.33-.1.5-.14A106.117,106.117,0,0,1,128.28,425.4",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27711",
    "data-name": "Path 27711",
    d: "M273.06,425.4c-.02.17-.05.34-.07.5H200.96c.04-.16.08-.33.11-.5q.585-2.865,1.08-5.77A180.342,180.342,0,0,0,65.71,217.347a176.225,176.225,0,0,0-65.21-2c-.17.02-.34.05-.5.08V143.3c.17-.03.33-.04.5-.06a246.924,246.924,0,0,1,84.94,5.36v-.01c125.9,29.95,206.24,151.14,187.62,276.81",
    fill: "#a1a1b3"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuarterCircle);
export default __webpack_public_path__ + "static/media/QuarterCircle.5bbe01ab07e314c4167c4d3295577ff9.svg";
export { ForwardRef as ReactComponent };